var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSDG)?_c('div',[_c('CustomFieldVocabularySDG',{attrs:{"attributes":_vm.attributes}})],1):(_vm.isSDG2)?_c('div',[_c('CustomFieldVocabularySDG2',{attrs:{"attributes":_vm.attributes}})],1):_c('div',[_vm._l((_vm.vocabularies),function(ref){
var id = ref.id;
var name = ref.name;
var group = ref.group;
var term = ref.term;
var hasLink = ref.hasLink;
return [(hasLink)?_c('router-link',{key:id,staticClass:"project-description__link",attrs:{"to":{ name: _vm.routes.TERM, params: Object.assign({}, _vm.params, {id: group, term: term}) }}},[_vm._v("\n      "+_vm._s(name)+"\n    ")]):_c('div',{key:id},[_vm._v("\n      "+_vm._s(name)+"\n    ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }